'use client'
import { useI18n } from '@dustin-web/microsite-components/src/i18n'
import ProductAvailability from './product-availability'
import NewProductAvailability from './product-availability-test'
import { useSiteContext } from '@dustin-web/microsite-components/src/hooks'
import type { GenericAvailabilityType } from '../cards'
import {
  getAvailabilityInfo,
  getAvailabilityType,
  getOriginAvailabilityInfo,
} from './availability.utils'
import ErrorBoundary from '@dustin-web/microsite-components/src/utils/error-boundary'

import ProductAvailabilityContainerV2 from '../product-availability-v2/product-availability-container'
import { useFeatureFlag } from '@dustin-web/microsite-data/src/feature-flags/client'

type Props = {
  availability?: GenericAvailabilityType | null
  isBid?: boolean
  showIsBidInfoText?: boolean
  listForm?: boolean
  className?: string
  iconClassName?: string
  showOnlyIcon?: boolean
  availabilityTextClassName?: boolean
  defaultContainerClassName?: string
  deliveryContainerClassName?: string
  containerClassNames?: string
  infoTextClassName?: string
  compactStatus?: boolean
}

const Container = (props: Props) => {
  const { translate, translationsExist } = useI18n()
  const { sourcingCompany } = useSiteContext()
  if (!props.availability) return null

  const isNewAvailability =
    !props.isBid && getAvailabilityType(props.availability) !== 'NOT_MIGRATED_TYPE'

  if (isNewAvailability) {
    const text = getAvailabilityInfo(
      props.availability,
      translate,
      translationsExist,
      false, // we dont want to show new status on bid products
      sourcingCompany === 'NL'
    )
    return (
      <NewProductAvailability
        text={{ ...text, bidInfo: translate('availabilitytext_bid_info') }}
        {...props}
      />
    )
  } else {
    const text = getOriginAvailabilityInfo(
      props.availability,
      translate,
      translationsExist,
      props.listForm,
      props.isBid
    )
    return (
      <ProductAvailability
        color={text.color}
        text={{ ...text, bidInfo: translate('availabilitytext_bid_info') }}
        isEstimatedShippingDate={text.isEstimatedShippingDate}
        {...props}
      />
    )
  }
}

export default function ProductAvailabilityContainer(props: Props) {
  const { enabled: isProductAvailabilityV2Enabled } = useFeatureFlag('wt-product-availability-v2')

  return (
    <ErrorBoundary>
      {isProductAvailabilityV2Enabled ? (
        <ProductAvailabilityContainerV2 {...props} />
      ) : (
        <Container {...props} />
      )}
    </ErrorBoundary>
  )
}
